import {Component, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {HistoryDataGraphComponent} from './history-data-graph.component';

/**
 * This class is a wrapper around actual ghaph implementation to do wrapper tasks.
 * @arnab.chakraborty@pathcom.com
 */
@Component({
  selector: 'app-history-data-view',
  templateUrl: './history-data-view.component.html',
  styleUrls: ['./history-data-view.component.css']
})
export class HistoryDataViewComponent implements OnInit {
  @ContentChildren(HistoryDataGraphComponent)
  graphComponentQueryList: QueryList<HistoryDataGraphComponent>;
  private _graphs: Array<HistoryDataGraphComponent> = [];

  constructor() {
  }

  ngOnInit() {

  }

}
